import {changePageTitle, setAlert} from "../redux/actions";
import {BusinessSegmentService} from "./business-segment.service";
import CustomTextField from "../custom-text-field/custom-text-field";
import CustomButton from "../custom-button/custom-button";
import CustomButtonGroup from "../custom-button-group/custom-button-group";
import {BusinessSegment} from "./business-segment";
import React, {FormEvent, useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";

interface BusinessSegmentDetailProps {
    id?: number | null;
    dialog?: boolean;
    onClose?: (businessSegment?: BusinessSegment) => void;
}

export function BusinessSegmentDetail({id, dialog, onClose}: BusinessSegmentDetailProps) {

    const [item, setItem] = useState(BusinessSegmentService.createBusinessSegment());
    const dispatch = useDispatch();

    const findOne = useCallback(async (id: number) => {
        const result = await BusinessSegmentService.findOne(id);
        setItem(result);
    }, []);

    useEffect(() => {
        if (!dialog) {
            dispatch(changePageTitle(id ? "Segmento de negócio " + id : "Novo segmento de negócio"));
        }
        if (id) {
            findOne(id).then();
        }
    }, [id, dialog]); // eslint-disable-line react-hooks/exhaustive-deps

    const save = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        BusinessSegmentService.save(item).then((result) => {
            if (onClose) {
                onClose(result.data);
            }
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao salvar registro - ' + error.response.data.message,
                severity: 'error'
            }));
        })
    }

    const cancel = () => {
        if (onClose) {
            onClose();
        }
    }

    const setDescription = (event: React.ChangeEvent<HTMLInputElement>) => {
        setItem({
            ...item,
            description: event.target.value
        })
    }

    return (
        <form onSubmit={save}>
            <CustomTextField fullWidth autoFocus required label="Descrição" value={item.description}
                             onChange={setDescription}/>
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Salvar</CustomButton>
                <CustomButton type="button" color="neutral" onClick={cancel}>Cancelar</CustomButton>
            </CustomButtonGroup>
        </form>
    )

}
